<template lang="pug">
.reports-page
  .title-section Reportes

  .report-item(@click="navigateTo('/reports/sales')")
    span.material-symbols-outlined.report-item-icon show_chart
    .report-item-info
      .report-item-name Ventas
      .report-item-description Reporte de ventas y comisiones

  .report-item(@click="navigateTo('/reports/deliveries')")
    span.material-symbols-outlined.report-item-icon local_shipping
    .report-item-info
      .report-item-name Entregas
      .report-item-description Reporte de entregas realizadas

  .report-item(@click="navigateTo('/reports/invoices')")
    span.material-symbols-outlined.report-item-icon description
    .report-item-info
      .report-item-name Facturas
      .report-item-description Reporte de facturación

  .report-item(@click="navigateTo('/reports/stock')")
    span.material-symbols-outlined.report-item-icon inventory_2
    .report-item-info
      .report-item-name Stock
      .report-item-description Valor del inventario por categoría
</template>

<script>
export default {
  name: 'Reports',

  methods: {
    navigateTo (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style lang="stylus" scoped>
.reports-page
  padding 1em 0
  text-align left

.report-item
  display flex
  align-items center
  gap 1.5em
  border-top 1px solid rgba(0, 0, 0, .2)
  padding 1.5rem 1rem
  cursor pointer
  color var(--color-font-principal)

.report-item:hover
  background-color rgba(0, 0, 0, .03)

.report-item-icon
  font-size 2.2rem
  opacity .5
  flex-shrink 0

.report-item-name
  font-size 1.3rem
  font-weight 600
  margin-bottom .3em

.report-item-description
  font-size 1.1rem
  opacity .55
</style>



// WEBPACK FOOTER //
// src/components/pages/reports/Reports.vue